import React from 'react'
import { Message } from 'rsuite'
import { Link } from 'react-router-dom'

export default function CustomMessages({ datas, ...props }) {
  const { style } = props

  const styles = { marginBottom: 10 }
  const linkStyle = { fontWeight: 'bold', marginLeft: 5 }

  if (style) {
    styles = { ...style }
  }

  return (
    <>
      {datas?.map((e, index) => (
        <>
          <Message
            type={e.type}
            showIcon={e.showIcon}
            description={
              <p>
                {e.description}
                {e.link && (
                  <>
                    {e.linkType == 'internal' ? (
                      <Link to={e.link} style={linkStyle}>
                        <u>{e.linkLabel}</u>
                      </Link>
                    ) : (
                      <a href={e.link} style={linkStyle} target="_blank">
                        <u>{e.linkLabel}</u>
                      </a>
                    )}
                  </>
                )}
              </p>
            }
            style={styles}
          />
        </>
      ))}
    </>
  )
}
